import { proNavigator } from "single-spa/react-app/ProNavigator";

export const getPeriodOverPeriodMaxAllowedDuration = (): string | null =>
    proNavigator.current().periodOverPeriodMaxAllowedDuration;
